import { render } from "./Cart.vue?vue&type=template&id=1f1edcc0&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=ts"
export * from "./Cart.vue?vue&type=script&lang=ts"

import "./Cart.vue?vue&type=style&index=0&id=1f1edcc0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f1edcc0"

export default script